<template>
  <div class="order">
    <van-nav-bar title="学生考勤" left-arrow @click-left="$router.go(-1)" />
    <van-cell title="选择日期" :value="starttime" @click="showDate('start')" />
    <van-calendar v-model="show" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" :show-confirm="false" />
    <van-button type="primary" class="search-btn" block @click="getList">开始查询</van-button>
    <div v-if="list.length == 0">
      <van-empty description="暂无记录" />
    </div>
    <div v-else>
      <div v-for="item in list" :key="item.title">
        <div style="padding: 10px 10px;font-size: 14px;">
          <p>{{ item.title }}总人数: {{ item.content.start_late.length + item.content.start_absence.length +
            item.content.start_normal.length }}</p>
        </div>
        <van-cell title="上学迟到" is-link :value="item.content.start_late.length" @click="goList(item.content.start_late)"/>
        <van-cell title="上学缺勤" is-link :value="item.content.start_absence.length" @click="goList(item.content.start_absence)"/>
        <van-cell title="上学到勤" is-link :value="item.content.start_normal.length" @click="goList(item.content.start_normal)"/>
        <van-cell title="放学早退" is-link :value="item.content.end_late.length" @click="goList(item.content.end_late)"/>
        <van-cell title="放学缺勤" is-link :value="item.content.end_absence.length" @click="goList(item.content.end_absence)"/>
        <van-cell title="放学到勤" is-link :value="item.content.end_normal.length" @click="goList(item.content.end_normal)"/>
      </div>
    </div>

  </div>
</template>

<script>

import { zouduGetAttendancData } from '@/api/teacher'
export default {
  name: 'zouduAccessRecord',
  components: {},
  data() {
    return {
      show: false,
      starttime: new Date().toLocaleDateString(),
      datetype: '',
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2040, 0, 31),
      page: 1,
      list: [],
      currentClass: {}
    }
  },
  mounted() {
    this.currentClass = JSON.parse(localStorage.getItem('currentClass'))
    this.getList()
  },
  methods: {
    async getList() {
      if (!this.starttime) {
        this.$toast('请选择开始结束日期')
        return
      }
      let params = {
        starttime: this.starttime,
        number: this.currentClass.number
      }
      const response = await zouduGetAttendancData(params)
      console.log('response', response);
      if (response.code == 10000) {
        this.list = response.data
      }
    },
    showDate(type) {
      this.datetype = type
      this.show = true
    },

    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      if (this.datetype === 'start') {
        this.starttime = this.formatDate(date);
      } else {
        this.endtime = this.formatDate(date);
      }
    },
    goList(data){
      if(data.length==0){
        this.$toast('暂无数据')
        return
      }
      console.log('data',data)
      this.$router.push({ path: '/detail_list', query: { data: JSON.stringify(data) } })
    }
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}

.van-tabs {
  position: sticky;
  top: 0;
}

.search-btn {
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}

.access_box {
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;

}
</style>
